import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { ProductApiModel } from 'app/models/product-api.model';

export const loadProducts = createAction(
  '[Products] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadProductsSuccess = createAction(
  '[Products] Load Successful',
  props<{ response: MwPayloadModel<ProductApiModel[]> }>()
);

export const loadProductsFailed = createAction(
  '[Products] Load Failed',
  props<{ error: any }>()
);

export const createProduct = createAction(
  '[Products] Create',
  props<{ product: ProductApiModel }>()
);

export const createProductSuccess = createAction(
  '[Products] Create Successful'
);

export const createProductFailed = createAction(
  '[Products] Create Failed',
  props<{ error: any }>()
);

export const updateProduct = createAction(
  '[Products] Update',
  props<{ product: ProductApiModel }>()
);

export const updateProductSuccess = createAction(
  '[Products] Update Successful'
);

export const updateProductFailed = createAction(
  '[Products] Update Failed',
  props<{ error: any }>()
);

export const deleteProduct = createAction(
  '[Products] Delete',
  props<{ product: ProductApiModel }>()
);

export const deleteProductSuccess = createAction(
  '[Products] Delete Successful'
);

export const deleteProductFailed = createAction(
  '[Products] Delete Failed',
  props<{ error: any }>()
);

export const deleteProductsList = createAction(
  '[Products] Delete List',
  props<{ products: ProductApiModel[] }>()
);

export const deleteProductsListSuccess = createAction(
  '[Products] Delete List Successful'
);

export const deleteProductsListFailed = createAction(
  '[Products] Delete List Failed',
  props<{ error: any }>()
);

export const resetProducts = createAction('[Products] Reset');
